<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ mType == '2' ? '行政采购项目' : '人力资源项目' }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: mType == '2' ? '/admin' : '/human' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: `/admin/view?id=${query.cid ? query.cid : query.pid}&mType=${mType}` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}预算说明</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="base1">
      <h3 class="ntitle">子项目信息</h3>
      <ul>
        <li>
          <p>
            <label>子项目名称：</label><a>{{ form.projectSonArr.contract_name }}</a>
          </p>
          <p>
            <label>项目时间：</label><a>{{ form.projectSonArr.start_time }} - {{ form.projectSonArr.end_time }}</a>
          </p>
        </li>
        <li>
        </li>
      </ul>
    </div>
    <!-- 预算说明 -->
    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="180px" label-position="left">
        <div class="formtitle">预算说明</div>
        <el-form-item label="预算金额：" prop="budget">
          <el-col :span="12">
            <el-input placeholder="请输入" maxlength="100" v-model="form.budget" clearable @click="v => numberFn(v)"
              :disabled="form.budget_status == '3' && level != 1" />
          </el-col>
        </el-form-item>
        <el-form-item label="选择支付类别：" prop="pay_type">
          <el-col :span="12">
            <el-select v-model="form.pay_type" placeholder="请选择" style="margin-right: 0; width: 100%;"
              :disabled="form.budget_status == '3' && level != 1">
              <el-option label="正常" value="1"></el-option>
              <el-option label="预支" value="2"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="选择合同情况：" prop="contract_id_type">
          <el-col :span="12">
            <el-select v-model="form.contract_id_type" placeholder="请选择" style="margin-right: 0; width: 100%;"
              :disabled="form.budget_status == '3' && level != 1">
              <el-option label="正常合同" value="1"></el-option>
              <el-option label="无需合同" value="2"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="选择服务类目：" prop="service_type">
          <el-col :span="12">
            <span class="service_type_span">{{ form.service_type_name ? form.service_type_name : '暂无' }}</span>
            <el-button @click="isService = true">{{ form.service_type_name ? '修改' : '选择' }}服务类目</el-button>
          </el-col>
        </el-form-item>
        <el-form-item label="采购事由：" prop="service_info">
          <el-col :span="12">
            <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
              v-model="form.service_info">
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="选择关联客户项目：" prop="customer_project_id"
          v-show="dd.asso_service_type.includes(form.service_type)">
          <el-col :span="12">
            <el-select v-model="form.customer_project_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="v => getAssoSonList(v)" clearable filterable>
              <el-option :label="`${v.contract_name} - ${v.brand}`" :value="v.id" v-for="(v, i) in assoList"
                :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="选择关联客户子项目：" prop="customer_son_project_id" v-show="form.service_type == '63'">
          <el-col :span="12">
            <el-select v-model="form.customer_son_project_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
              clearable filterable>
              <el-option :label="v.contract_name" :value="v.id" v-for="(v, i) in assoSonList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="选择关联员工：" prop="customer_user_id_arr" v-if="query.mType == '3'">
          <el-col :span="18">
            <el-checkbox-group v-model="form.customerUserArr" class="customer">
              <div v-for="(item, index) in userArr" :key="`user_${index}`" class="customer-box">
                <el-checkbox :label="item.user_dep_id" :indeterminate="item.isIndeterminate" @change="handleParentChange(item)" class="customer-label">
                  {{ item.title }}
                </el-checkbox>
                <el-checkbox-group v-if="item.child && item.child.length" v-model="form.customerUserArr" class="customer-group">
                  <el-checkbox v-for="(cItem, cIndex) in item.child" :key="`user_${index}_child_${cIndex}`" :label="cItem.id"  @change="e => handleChildChange(e, cItem, item)">
                    {{ cItem.realname }} {{ cItem.en_name }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-checkbox-group>
          </el-col>
        </el-form-item>
        <template>
          <ul class="anlist">
            <li v-for="(item, index) in fileList" :key="index">
              <div class="abox">
                <el-form-item :label='`清单附件${index + 1}：`'>
                  <!-- 选择文件 -->
                  <el-col :span="3">
                    <el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
                      :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                      :on-change="(arg) => uploadFile(arg, 'fileList', 'upFile', item, index)">
                      <el-button size="small" style="width: 100%">选择文件</el-button>
                    </el-upload>
                  </el-col>
                  <!-- 文件预览及下载 -->
                  <template v-if="item.origin_name">
                    <el-col :span="10">
                      <el-col :span="18">
                        <div class="origin-name">{{ item.origin_name }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                          target="_blank">查看</el-link>
                      </el-col>
                    </el-col>
                  </template>
                </el-form-item>
              </div>
              <el-button class="bbtn" icon="el-icon-minus" @click="removeImage(fileList, index)" circle></el-button>
            </li>
            <el-button type="primary" style="margin: 0 0 15px 180px;" class="addbtn"
              @click="addImage(fileList)">新增清单附件</el-button>
          </ul>
        </template>
        <el-form-item label="">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>

      </el-form>
    </div>

    <el-dialog title="重要提醒" :visible.sync="remindShow" width="800px">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>切换支付类型之后，供应商及支付计划需要重新选择</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remindShow = false">取 消</el-button>
        <el-button type="primary" @click="handleRemind">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="预算已删除" :show-close="false" :close-on-click-modal="false" :visible.sync="isDel" width="800px">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>预算已删除</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goBack">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择服务类目" :close-on-click-modal="false" :visible.sync="isService" width="1000px">
      <div class="service-block" v-for="(item, index) in ServiceFoldList" :key="`serv_${index}`">
        <div class="block-title">{{ item.category_name }}</div>
        <ul>
          <li class="b-item" v-for="(_it, _id) in item.child" :key="`serv_${index}_${_id}`">
            <div class="li-title" :class="{ 'chosed': _it.isChose }" @mouseenter.stop="showInfoFn(_it)"
              @mouseleave.stop="hideInfoFn(_it)" @click.stop="choseInfoFn(_it)">{{ _it.category_name }}<i
                class="el-icon-success"></i></div>
            <div class="li-con" :class="{ 'li-show': _it.isShow }">{{ _it.info }}</div>
          </li>
        </ul>
      </div>
    </el-dialog>

  </el-main>
</template>

<script>
import * as api from '@/api'
// import { timeFormat } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'ahpaydetail',
  data() {
    return {
      nodeLimtList: [],
      isDel: false,
      mType: '',
      assoList: [],
      assoSonList: [],
      userList: [],
      userArr: [],
      level: '',
      pay_type: '1',
      remindShow: false,
      canChangeVendor: true,
      nowCost: '0.00',
      projectList: [],//项目列表
      projectArr: {

      },//项目详情
      billList: [],//收款计划
      sonList: [],//子项目
      purchaseList: [],//供应商合同列表
      vendorList: [],//供应商列表
      form: {
        pay_id: '',
        project_id: '',
        son_project_id: '',
        contract_name: '',
        contract_no: '',
        pay_info: '',
        vendor_id: '',
        vendor_type: '',
        budget: '',
        pay_type: '1',
        service_type: '',
        service_info: '',
        contract_id: '',
        contract_id_type: '1',//0代表有合同 -1代表没合同
        check_info: '',
        atta_str: '',
        projectArr: {//项目详情
          contract_name: '',
        },
        projectSonArr: {//子项目详情
          contract_name: '',
        },
        del_atta_list: [],
        customerUserArr: [],
        customer_project_id: '',
        customer_son_project_id: '',
      },
      rules: {
        budget: [
          {
            required: true,
            message: '请输入预算',
            trigger: 'change',
          },
        ],
        pay_type: [
          {
            required: true,
            message: '请选择支付类别',
            trigger: 'change',
          },
        ],
        contract_id_type: [
          {
            required: true,
            message: '请选择合同情况',
            trigger: 'change',
          },
        ],
        service_type: [
          {
            required: true,
            message: '请选择服务类目',
            trigger: 'change',
          },
        ],
        service_info: [
          {
            required: true,
            message: '请输入采购事由',
            trigger: 'change',
          },
        ],
      },
      fileList: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      fileList1: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      del_atta_list: [],
      del_atta_list1: [],
      del_plan_list: [],
      ServiceFoldList: [], //折叠
      isService: false,
    }
  },
  created() {
    this.query = this.$route.query
    this.mType = this.query.mType
    this.query.id && this.getDetail(this.query.id)
    this.query.pid && (this.form.project_id = this.query.pid) && this.projectChange(this.query.pid)
  },
  mounted() {
    // this.getServiceList()
    this.getAssoList()
    this.getUserList()
    this.getUserDepList()
    this.getServiceFoldList();
  },
  watch: {

  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;
      // 移除'#'字符  
      const url = hash.substring(1);

      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    async getServiceFoldList() {
      this.$fly
        .post("ApiAdministrative_selectTypeList.html", {
          mType: this.mType
        })
        .then(res => {
          this.ServiceFoldList = res.map(item => {
            item.child = item.child.map(i => {
              i.isShow = false
              i.isChose = false
              return i
            })
            return item
          })
        });
    },
    // async getServiceList() {
    //   this.$fly
    //     .post('ApiAdministrative_serviceTypeDropdownList.html', {
    //       per_page: 5000,
    //       id: this.mType == '2' ? '8' : '9'
    //     })
    //     .then((res) => {
    //       this.serviceList = res
    //     })
    // },
    async getAssoList() {
      this.$fly
        .post('ApiAdministrative_projectDropdownList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.assoList = res
        })
    },
    async getUserList() {
      this.$fly
        .post('apiAccount_getUserList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.userList = res.itemList.filter(item => item.status == '1')
        })
    },
    async getUserDepList() {
      const that = this
      that.$fly
        .post('apiAccount_getUserListByDep.html', {
          per_page: 5000,
        })
        .then((res) => {
          that.userArr = res.map((item, index) => {
            item.user_dep_id = '1000' + index
            item.checkedChildren = [] // 用于存储被选中的子选项 
            item.isIndeterminate = false
            return item
          })
        })
    },
    serviceChange() {
      this.form.customer_project_id = ''
      this.form.customer_son_project_id = ''
    },
    getAssoSonList(pid) {
      this.form.customer_son_project_id = ''
      this.$fly
        .post('ApiAdministrative_getCustomerProjectList', {
          project_id: pid,
        })
        .then((res) => {
          this.assoSonList = res
          this.$forceUpdate()
        })
    },
    numberFn(v) {
      v = v.toString().replace(/,/g, "")
      this.form.budget = Number(v)
    },
    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 4);
      api.uploadFile(formData)
        .then((res) => {
          this[fileList][index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][index].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addImage(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
    },
    projectChange(v) {
      this.form = {
        ...this.form,
        son_project_id: '',
      }
      if (v) {
        this.$fly
          .post('ApiAdministrative_projectDetail', { id: v })
          .then((res) => {
            this.projectArr = res.item_info
            this.form.projectArr = res.item_info
            this.billList = res.billList
            this.sonList = res.son_list
            this.sonList.forEach(item => {
              if (item.id == this.query.sid) {
                this.form.projectSonArr = item
                this.form.son_project_id = item.id
              }
            })
          })
      }
    },
    getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      this.$fly
        .post('ApiAdministrative_getPayDetail.html', {
          pay_id: id,
        })
        .then((res) => {
          let form = res.itemArr
          form.contract_id_type = form.contract_id == '-1' ? '2' : '1'
          this.isDel = form.is_del == '0' ? false : true
          // const atta_str = () => [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
          this.fileList = res.itemArr.fileList.filter(item => item.file_type == '1').map((item) => {
            delete item.project_id
            delete item.create_time
            item.flist = []
            return item
          })
          if (this.fileList.length === 0) {
            this.fileList = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
          }
          this.$fly
            .post('ApiAdministrative_projectDetail', { id: form.projectArr.id })
            .then((res) => {
              this.projectArr = res.item_info
              this.billList = res.billList
              this.sonList = res.son_list
            })
          this.pay_type = form.pay_type
          for (let i = 0; i < this.ServiceFoldList.length; i++) {
            let _child = this.ServiceFoldList[i].child;
            for (let j = 0; j < _child.length; j++) {
              const ele_id = _child[j].id;
              if (ele_id == res.itemArr.service_type) {
                _child[j].isChose = true
              }
            }
          }
          this.$forceUpdate()
          if (form.customer_project_id != '0') {
            this.getAssoSonList(form.customer_project_id)
          }
          if (form.customer_user_id) {
            form.customerUserArr = form.customer_user_id.split(',').filter((s) => {
              return s && s.trim();
            })
          }
          for (let i = 0; i < this.userArr.length; i++) {
            let userArrItem = this.userArr[i];
            for (let j = 0; j < userArrItem.child.length; j++) {
              const userArrItemChild = userArrItem.child[j];
              if (form.customerUserArr.includes(userArrItemChild.id)) {
                userArrItem.checkedChildren.push(userArrItemChild.id)
              }
            }
            userArrItem.isIndeterminate = this.isIndeterminateFn(userArrItem)
          }
          setTimeout(() => {
            //权限
            this.level = store.state.level
            this.realName = store.state.realName
          }, 200);
          this.form = form
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if ((this.pay_type != this.form.pay_type) && this.query.id) {
            this.remindShow = true
          }
          else {
            this.addUpdatePay()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleRemind() {
      this.addUpdatePay()
    },
    addUpdatePay() {
      if (this.form.budget == '0.00' || this.form.budget == 0) {
        this.$message.error('预算不能为0')
        return false
      }
      this.form.pay_id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      //替换掉id为file_id
      let fileList = this.fileList.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 1
        return item
      })
      let fileList1 = this.fileList1.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 2
        return item
      })
      fileList = fileList.concat(fileList1)
      let del_atta_list = this.del_atta_list
      let del_atta_list1 = this.del_atta_list1
      const del_atta = del_atta_list.concat(del_atta_list1)
      const $fileList = fileList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['file_id'] = item[key]
            console.log(item['file_id']);
            delete item[key]
          }
        })
        return item
      })
      fileList = $fileList
      this.form.customer_user_id = this.mType == '3' ? this.form.customerUserArr.toString() : ''
      console.log(this.form.customer_user_id);
      const tempForm = JSON.parse(JSON.stringify(this.form))
      if ((this.pay_type != this.form.pay_type) && this.query.id) {
        tempForm.vendor_id = ''
        tempForm.contract_id = ''
        for (let i = 0; i < tempForm.planList.length; i++) {//删除全部计划
          const _id = tempForm.planList[i].id;
          this.del_plan_list.push(_id);
        }
      }
      delete tempForm.projectArr
      delete tempForm.projectSonArr
      delete tempForm.customerProjectArr
      delete tempForm.vendorArr
      delete tempForm.vendorContractArr
      delete tempForm.invoiceList
      delete tempForm.planList
      delete tempForm.fileList
      delete tempForm.budget_status//如果不是预算审核，budget_status 字段不能传
      delete tempForm.customerUserArr
      tempForm.contract_id = tempForm.contract_id_type == '2' ? '-1' : (tempForm.contract_id > 0 ? tempForm.contract_id : 0)
      this.$fly
        .post('ApiAdministrative_createOrUpdateSubProjectBudget.html', {
          ...tempForm,
          atta_str: JSON.stringify(fileList),
          atta_del: del_atta.toString(),
          plan_del: this.del_plan_list.toString(),
          mType: this.mType
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
    goBack() {
      this.$router.go(-1)
    },
    showInfoFn(item) {
      item.isShow = true
    },
    hideInfoFn(item) {
      item.isShow = false
    },
    choseInfoFn(item) {
      for (let i = 0; i < this.ServiceFoldList.length; i++) {
        let serv_ = this.ServiceFoldList[i].child;
        for (let j = 0; j < serv_.length; j++) {
          let item_ = serv_[j];
          item_.isChose = false;
        }
      }
      item.isChose = true;
      this.form.service_type = item.id;
      this.form.service_type_name = item.category_name;
      this.isService = false
    },
    handleParentChange(parent) {
      if (this.form.customerUserArr.includes(parent.user_dep_id)) {
        for (let i = 0; i < parent.child.length; i++) {
          const element = parent.child[i];
          if (!this.form.customerUserArr.includes(element.id)) this.form.customerUserArr.push(element.id);//先验重再添加
          if (!parent.checkedChildren.includes(element.id)) parent.checkedChildren.push(element.id);
          this.$forceUpdate()
        }
      } else {
        for (let i = 0; i < parent.child.length; i++) {
          const element = parent.child[i];
          //从总集中删除
          const index1 = this.form.customerUserArr.indexOf(element.id);
          if (index1 > -1) {
            this.form.customerUserArr.splice(index1, 1);
          }
          //从父元素中也删除
          const index2 = parent.checkedChildren.indexOf(element.id);
          if (index2 > -1) {
            parent.checkedChildren.splice(index2, 1);
          }
          this.$forceUpdate()
        }
      }
      parent.isIndeterminate = this.isIndeterminateFn(parent);
    },
    handleChildChange(e, item, parent) {
      if (e) {
        parent.checkedChildren.push(item.id);
      }
      else {
        const index = parent.checkedChildren.indexOf(item.id);
        parent.checkedChildren.splice(index, 1);
      }
      this.checkParent(parent);
      parent.isIndeterminate = this.isIndeterminateFn(parent);
    },
    checkParent(parent) {
      // 处理父选项变化  
      if (parent.checkedChildren.length === parent.child.length) {
        // 如果所有子选项都被选中，则父选项也应该是选中的  
        if (!this.form.customerUserArr.includes(parent.id)) this.form.customerUserArr.push(parent.user_dep_id);
      } else if (parent.checkedChildren.length > 0) {
        // 如果有部分子选项被选中，则父选项应该是半选的（但Element UI不直接支持，这里只是逻辑处理）  
        // 注意：这里只是逻辑上的处理，实际上Element UI的checkbox不支持半选状态  
      }
      else {
        // 如果没有子选项被选中，则从this.form.customerUserArr中移除父选项  
        const index = this.form.customerUserArr.indexOf(parent.user_dep_id);
        if (index > -1) {
          this.form.customerUserArr.splice(index, 1);
        }
      }
    },
    // 如果true true 或者 false true样式为-;
    // true false样式为√;
    // 如果false false样式为不勾;
    isIndeterminateFn(item) {
      // 判断父选项是否应该为半选状态  
      // 注意：由于Element UI不支持直接的半选状态，这里只是返回一个布尔值供逻辑判断使用  
      if (item.checkedChildren.length == 0 || item.checkedChildren.length == item.child.length) {
        return false
      } else if (item.checkedChildren.length > 0) {
        return true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .ntitle {
      display: inline-block;
      margin: 0 0 25px 0;

      &::before {
        width: 100%;
      }
    }

    ul {
      @extend %start;
      color: #231f20;
      background: #f2f2f2;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }



          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }
        }
      }
    }

  }
}

.service_type_span {
  padding: 0 10px;
}

.service-block {
  @extend %start;
  align-items: flex-start;
  margin-bottom: 0;

  .block-title {
    width: 100px;
    padding: 10px 20px;
    background: #231f20;
    color: #fff;
    text-align: center;
  }

  ul {
    width: 100%;
    @extend %start;
    flex-flow: row wrap;
    align-items: flex-start;

    .b-item {
      width: 130px;
      margin: 4px 10px 24px;

      .li-con {
        display: none;

        &.li-show {
          display: block;
          opacity: 0;
          /* 初始状态为完全透明 */
          animation: fadeIn 1s;
          /* 调用fadeIn动画，持续时间为2秒 */
        }
      }

      &:nth-of-type(5n+0) {
        .li-con {
          left: -120px;
        }
      }

      &:nth-of-type(5n+1) {
        .li-con {
          left: -40px;
        }
      }

      &:nth-of-type(5n+2) {
        .li-con {
          left: -60px;
        }
      }

      &:nth-of-type(5n+3) {
        .li-con {
          left: -80px;
        }
      }

      &:nth-of-type(5n+4) {
        .li-con {
          left: -100px;
        }
      }

      .li-title {
        position: relative;
        padding: 5px 10px;
        border: 1px solid #231f20;
        border-radius: 5px;
        cursor: pointer;

        .el-icon-success {
          display: none;
          position: absolute;
          top: 50%;
          right: 2px;
          transform: translate(0, -50%);
        }

        &:hover {
          background: #ececec;
        }

        &.chosed {
          .el-icon-success {
            display: block;
          }
        }
      }

      .li-con {
        width: 250%;
        padding: 10px;
        background: #ececec;
        border-radius: 10px;
        border: 1px solid transparent;
        position: relative;
        top: 10px;
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.customer.el-checkbox-group {
  display: block;
  padding: 5px 10px;
  border-radius: 10px;
  background: #ececec;
  .customer-box {
    @extend %start;
    align-items: stretch;
    padding: 10px;
    border-radius: 10px;
    background: #fff;
    margin: 10px 0;
    .customer-label {
      width: 150px;
      border-right: 1px solid #ececec;
    }
    .customer-group {
      width: calc(100% - 150px);
      padding: 0 20px;
      border-radius: 10px;
      .el-checkbox {
        display: inline-block;
        width: calc(100% / 3 - 30px);
      }
    }
  } 
}
</style>
